export enum CommonStatusCode {
  OK = 200,
  CREATED = 201,
  UNAUTHORIZED = 403,
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,
}

/** All status codes for /user/me awaited as valid error (during signup) */
export const awaitedUserMeSignupErrorStatusCodes = new Set([CommonStatusCode.UNAUTHORIZED, CommonStatusCode.NOT_FOUND])
